import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import AboutUs from "./pages/AboutUs";
import Gallery from "./pages/Gallery";
import Reservations from "./pages/Reservations";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Impressum from "./pages/Impressum";
import AGB from "./pages/AGB";
import { Toaster } from "./components/ui/sonner";

function App() {
  // Sayfa yüklendiğinde en üste scroll yap - birden fazla yöntem
  useEffect(() => {
    // Hemen scroll
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    
    // Biraz gecikmeyle tekrar (tarayıcı restore'u engellemek için)
    const timer1 = setTimeout(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 0);
    
    const timer2 = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
    
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, []);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="App min-h-screen flex flex-col bg-gray-900">
          <ScrollToTop />
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<AboutUs />} />
              {/* English routes */}
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/reservations" element={<Reservations />} />
              <Route path="/contact" element={<Contact />} />
              {/* German routes */}
              <Route path="/galerie" element={<Gallery />} />
              <Route path="/reservierungen" element={<Reservations />} />
              <Route path="/kontakt" element={<Contact />} />
              {/* Privacy */}
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/datenschutz" element={<PrivacyPolicy />} />
              {/* Impressum */}
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/imprint" element={<Impressum />} />
              {/* AGB / Terms */}
              <Route path="/agb" element={<AGB />} />
              <Route path="/terms" element={<AGB />} />
            </Routes>
          </main>
          <Footer />
        </div>
        <Toaster />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
